<script lang="ts">
  import { Router, Route, NotFoundRoute, redirect } from "./utils/pager";
  import LoginPage from "./pages/Login/LoginPage.svelte";
  import DashboardPage from "./pages/Dashboard/DashboardPage.svelte";
  import ProfilePage from "./pages/Profile/ProfilePage.svelte";
  import NotFoundPage from "./pages/NotFound/NotFoundPage.svelte";
  import { isUserRoleADM, user } from "./app.store";
  import { initAppLogic, initialize } from "./app.logic";
  import { get } from "svelte/store";
  import UserListPage from "./pages/User/UserListPage.svelte";
  import SettingsPage from "./pages/Settings/SettingsPage.svelte";
  import UserDetailPage from "./pages/User/UserDetailPage.svelte";
  import LeadListPage from "./pages/Lead/LeadListPage.svelte";
  import LeadDetailPage from "./pages/Lead/LeadDetailPage.svelte";
  import CompanyListPage from "./pages/Company/CompanyListPage.svelte";
  import CompanyDetailPage from "./pages/Company/CompanyDetailPage.svelte";
  import ContactListPage from "./pages/Contact/ContactListPage.svelte";
  import ContactDetailPage from "./pages/Contact/ContactDetailPage.svelte";
  import ProductListPage from "./pages/Product/ProductListPage.svelte";
  import ProductDetailPage from "./pages/Product/ProductDetailPage.svelte";
  import DealListPage from "./pages/Deal/DealListPage.svelte";
  import DealDetailPage from "./pages/Deal/DealDetailPage.svelte";
  import InvoicesEmailsListPage from "./pages/InvoicesEmails/InvoicesEmailsListPage.svelte";

  import { onMount } from "svelte";
  import ReportPage from "./pages/Report/ReportPage.svelte"; 
  import ReportMagazinePage from "./pages/Report/Magazine/ReportMagazinePage.svelte";
import ActivityListPage from "./pages/Activity/ActivityListPage.svelte";
import ActivityDetailPage from "./pages/Activity/ActivityDetailPage.svelte";
import UnpaidPage from "./pages/Unpaid/UnpaidPage.svelte";
    import ProjectListPage from "./pages/Project/ProjectListPage.svelte";
    import ProjectDetailPartGeneral from "./pages/Project/ProjectDetailPartGeneral.svelte";

  const loginGuard = (_ctx: any, next: any) => {
    let u = get(user);
    if (u === null) {
      initialize();
    } else {
      // go to the next callback in the chain
      next();
    }
  };

  const adminGuard = (_ctx: any, next: any) => {
    let adm = get(isUserRoleADM);
    if (!adm) {
      redirect("/");
    } else {
      next();
    }
  };

  const defaultRouteGuard = (_ctx: any, _next: any) => {
    redirect("/dashboard");
  };

  onMount(initAppLogic);
</script>

<Router>
  <Route path="/" middleware={[loginGuard, defaultRouteGuard]}>
    <div class="initial-loader" />
  </Route>
  <Route path="/login" component={LoginPage} />
  <Route path="/profile" middleware={[loginGuard]} component={ProfilePage} />
  <Route
    path="/dashboard"
    middleware={[loginGuard]}
    component={DashboardPage}
  />
  <Route path="/lead" middleware={[loginGuard]} component={LeadListPage} />
  <Route
    path="/lead/:oid"
    middleware={[loginGuard]}
    component={LeadDetailPage}
  />
  <Route
    path="/company"
    middleware={[loginGuard]}
    component={CompanyListPage}
  />
  <Route
    path="/company/:oid"
    middleware={[loginGuard]}
    component={CompanyDetailPage}
  />
  <Route
    path="/supplier"
    middleware={[loginGuard]}
    component={CompanyListPage}
  />
  <Route
    path="/supplier/:oid"
    middleware={[loginGuard]}
    component={CompanyDetailPage}
  />
  <Route
  path="/task"
  middleware={[loginGuard]}
  component={ActivityListPage}
  />
  <Route
    path="/task/:oid/:type"
    middleware={[loginGuard]}
    component={ActivityDetailPage}
  />
  <Route
    path="/contact"
    middleware={[loginGuard]}
    component={ContactListPage}
  />
  <Route
    path="/contact/:oid"
    middleware={[loginGuard]}
    component={ContactDetailPage}
  />
  <Route
    path="/product"
    middleware={[loginGuard]}
    component={ProductListPage}
  />
  <Route
    path="/product/:oid"
    middleware={[loginGuard]}
    component={ProductDetailPage}
  />
  <Route
    path="/project"
    middleware={[loginGuard]}
    component={ProjectListPage}
  />
  <Route
    path="/project/:oid"
    middleware={[loginGuard]}
    component={ProjectDetailPartGeneral}
  />
  <Route path="/deal" middleware={[loginGuard]} component={DealListPage} />
  <Route
    path="/deal/:oid"
    middleware={[loginGuard]}
    component={DealDetailPage}
  />
  <Route
    path="/invoicesemails"
    middleware={[loginGuard]}
    component={InvoicesEmailsListPage}
  />
  <Route
    path="/reports"
    middleware={[loginGuard]}
    component={ReportPage}
  />
  <Route
    path="/reports/magazine"
    middleware={[loginGuard]}
    component={ReportMagazinePage}
  />
  <Route
    path="/unpaid"
    middleware={[loginGuard]}
    component={UnpaidPage}
  />
  <Route
    path="/user"
    middleware={[loginGuard, adminGuard]}
    component={UserListPage}
  />
  <Route
    path="/user/:oid"
    middleware={[loginGuard, adminGuard]}
    component={UserDetailPage}
  />
  <Route
    path="/settings"
    middleware={[loginGuard, adminGuard]}
    component={SettingsPage}
  />
  <NotFoundRoute>
    <NotFoundPage />
  </NotFoundRoute>
</Router>
